import request, { requestV2 } from "@/config/serve.js";

// api-组件管理
export function queryAssemblyList(data) {
  return request("post", "/assembly/queryAssemblyList", data);
}
export function updateAssembly(data) {
  return request("post", "/assembly/updateAssembly", data);
}
export function insertAssembly(data) {
  return request("post", "/assembly/insertAssembly", data);
}
export function queryAssemblyDescList(data) {
  return request("post", "/assembly/queryAssemblyDescList", data);
}
export function insertAssemblyDesc(data) {
  return requestV2("post", "/assembly/insertAssemblyDesc", data);
}
// 批量新增组件国际化描述
export function batchInsertAssemblyDesc(data) {
  return requestV2("post", "/assembly/batchInsertAssemblyDesc", data);
}
export function updateAssemblyDesc(data) {
  return request("post", "/assembly/updateAssemblyDesc", data);
}
export function deleteAssemblyDesc(data) {
  return request("post", "/assembly/deleteAssemblyDesc", data);
}
export function queryAssemblyApkList(data) {
  return request("post", "/assembly/queryAssemblyApkList", data);
}
export function queryAssemblyTypeList(data) {
  return request("post", "/assembly/queryAssemblyTypeList", data);
}
export function queryAssemblyStyleList(data) {
  return request("post", "/assembly/queryAssemblyStyleList", data);
}
export function queryApkCategoryLevelList(data) {
  return request("post", "/assembly/queryApkCategoryLevelList", data);
}
export function queryApkLabelList(data) {
  return request("post", "/assembly/queryApkLabelList", data);
}
export function queryApkCategoryList(data) {
  return request("post", "/assembly/queryApkCategoryList", data);
}
export function queryLanguageList(data) {
  return request("post", "/assembly/queryLanguageList", data);
}
export function insertApkList(data) {
  return requestV2("post", "/assembly/insertApkList", data);
}
export function queryApkListByAssemblyId(data) {
  return request("post", "/assembly/queryApkListByAssemblyId", data);
}
export function queryAssemblyPageList(data) {
  return requestV2("post", "/assembly/queryAssemblyPageList", data);
}
export function queryAssemblyDetail(data) {
  return request("post", "/assembly/queryAssemblyDetail", data);
}
// 查询市场部署的页面
export function getMarketDeployList(params) {
  return request("post", "/cmsPage/queryList", params);
}
export function getMarketList(params) {
  return request("post", "/market/manage/queryList", params);
}
//组件管理页面删除
export function deleteAssembly(params) {
  return request("post", "/assembly/deleteAssembly", params);
}
// 部署-查询gp应用分类信息(有层级)
export function queryApkGpCategoryLevelList(data) {
  return request("post", "/assembly/queryApkGpCategoryLevelList", data);
}
// 部署-查询GP推广资源
export function queryApkGpApkList(data) {
  return requestV2("post", "/assembly/queryGpApkList", data);
}
